import type { allTimeStats } from './useSessionStats';

/** One quiet line on home: what you solved today and this week. No streaks, no nudges. */
export function TodayLine({ stats }: { stats?: ReturnType<typeof allTimeStats> }) {
  if (!stats || !stats.days) return null;
  return (
    <p className="today-line" data-testid="today-line" aria-label="Today">
      <span>
        Today <strong data-testid="today-solved">{stats.todaySolved}</strong> solved
      </span>
      <span>
        <strong data-testid="week-solved">{stats.week}</strong> this week
      </span>
    </p>
  );
}
